var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0938 10.7812C18.6115 10.7812 19.0312 10.3615 19.0312 9.84375C19.0312 9.32598 18.6115 8.90625 18.0938 8.90625C17.576 8.90625 17.1562 9.32598 17.1562 9.84375C17.1562 10.3615 17.576 10.7812 18.0938 10.7812Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 1.875H19.0312V0.9375C19.0312 0.419719 18.6115 0 18.0938 0C17.576 0 17.1562 0.419719 17.1562 0.9375V1.875H12.8906V0.9375C12.8906 0.419719 12.4709 0 11.9531 0C11.4353 0 11.0156 0.419719 11.0156 0.9375V1.875H6.79688V0.9375C6.79688 0.419719 6.37716 0 5.85938 0C5.34159 0 4.92188 0.419719 4.92188 0.9375V1.875H3.75C1.68225 1.875 0 3.55725 0 5.625V20.25C0 22.3177 1.68225 24 3.75 24H10.9219C11.4397 24 11.8594 23.5803 11.8594 23.0625C11.8594 22.5447 11.4397 22.125 10.9219 22.125H3.75C2.71613 22.125 1.875 21.2839 1.875 20.25V5.625C1.875 4.59113 2.71613 3.75 3.75 3.75H4.92188V4.6875C4.92188 5.20528 5.34159 5.625 5.85938 5.625C6.37716 5.625 6.79688 5.20528 6.79688 4.6875V3.75H11.0156V4.6875C11.0156 5.20528 11.4353 5.625 11.9531 5.625C12.4709 5.625 12.8906 5.20528 12.8906 4.6875V3.75H17.1562V4.6875C17.1562 5.20528 17.576 5.625 18.0938 5.625C18.6115 5.625 19.0312 5.20528 19.0312 4.6875V3.75H20.25C21.2839 3.75 22.125 4.59113 22.125 5.625V10.9688C22.125 11.4865 22.5447 11.9062 23.0625 11.9062C23.5803 11.9062 24 11.4865 24 10.9688V5.625C24 3.55725 22.3177 1.875 20.25 1.875Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3281 12.6562C15.2006 12.6562 12.6562 15.2006 12.6562 18.3281C12.6562 21.4556 15.2006 24 18.3281 24C21.4556 24 24 21.4556 24 18.3281C24 15.2006 21.4556 12.6562 18.3281 12.6562ZM18.3281 22.125C16.2345 22.125 14.5312 20.4218 14.5312 18.3281C14.5312 16.2345 16.2345 14.5312 18.3281 14.5312C20.4217 14.5312 22.125 16.2345 22.125 18.3281C22.125 20.4218 20.4217 22.125 18.3281 22.125Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 17.3906H19.2656V16.4062C19.2656 15.8885 18.8459 15.4688 18.3281 15.4688C17.8103 15.4688 17.3906 15.8885 17.3906 16.4062V18.3281C17.3906 18.8459 17.8103 19.2656 18.3281 19.2656H19.6875C20.2053 19.2656 20.625 18.8459 20.625 18.3281C20.625 17.8103 20.2053 17.3906 19.6875 17.3906Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0156 10.7812C14.5334 10.7812 14.9531 10.3615 14.9531 9.84375C14.9531 9.32598 14.5334 8.90625 14.0156 8.90625C13.4979 8.90625 13.0781 9.32598 13.0781 9.84375C13.0781 10.3615 13.4979 10.7812 14.0156 10.7812Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 14.8594C10.4553 14.8594 10.875 14.4396 10.875 13.9219C10.875 13.4041 10.4553 12.9844 9.9375 12.9844C9.41973 12.9844 9 13.4041 9 13.9219C9 14.4396 9.41973 14.8594 9.9375 14.8594Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 10.7812C6.37714 10.7812 6.79688 10.3615 6.79688 9.84375C6.79688 9.32598 6.37714 8.90625 5.85938 8.90625C5.34161 8.90625 4.92188 9.32598 4.92188 9.84375C4.92188 10.3615 5.34161 10.7812 5.85938 10.7812Z",
    fill: "url(#paint6_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 14.8594C6.37714 14.8594 6.79688 14.4396 6.79688 13.9219C6.79688 13.4041 6.37714 12.9844 5.85938 12.9844C5.34161 12.9844 4.92188 13.4041 4.92188 13.9219C4.92188 14.4396 5.34161 14.8594 5.85938 14.8594Z",
    fill: "url(#paint7_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85938 18.9375C6.37714 18.9375 6.79688 18.5178 6.79688 18C6.79688 17.4822 6.37714 17.0625 5.85938 17.0625C5.34161 17.0625 4.92188 17.4822 4.92188 18C4.92188 18.5178 5.34161 18.9375 5.85938 18.9375Z",
    fill: "url(#paint8_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 18.9375C10.4553 18.9375 10.875 18.5178 10.875 18C10.875 17.4822 10.4553 17.0625 9.9375 17.0625C9.41973 17.0625 9 17.4822 9 18C9 18.5178 9.41973 18.9375 9.9375 18.9375Z",
    fill: "url(#paint9_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 10.7812C10.4553 10.7812 10.875 10.3615 10.875 9.84375C10.875 9.32598 10.4553 8.90625 9.9375 8.90625C9.41973 8.90625 9 9.32598 9 9.84375C9 10.3615 9.41973 10.7812 9.9375 10.7812Z",
    fill: "url(#paint10_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 18.8778,
    y1: 9.05991,
    x2: 17.1528,
    y2: 10.5976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.0354,
    y1: 1.96687,
    x2: -0.0447851,
    y2: 21.6491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 23.0714,
    y1: 13.5859,
    x2: 12.6351,
    y2: 22.8888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 20.3602,
    y1: 15.7799,
    x2: 16.9732,
    y2: 18.3519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.7996,
    y1: 9.05991,
    x2: 13.0746,
    y2: 10.5976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10.7215,
    y1: 13.138,
    x2: 8.9965,
    y2: 14.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 6.64339,
    y1: 9.05991,
    x2: 4.91838,
    y2: 10.5976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 6.64339,
    y1: 13.138,
    x2: 4.91838,
    y2: 14.6757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 6.64339,
    y1: 17.2162,
    x2: 4.91838,
    y2: 18.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 10.7215,
    y1: 17.2162,
    x2: 8.9965,
    y2: 18.7538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 10.7215,
    y1: 9.05991,
    x2: 8.9965,
    y2: 10.5976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8568FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D8FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f192df5eae5d2f2ddc7b50b5e077ff6b.svg";
export { ForwardRef as ReactComponent };